interface Filter {
  key: string
  label: string
}

interface ShiftSwapFiltersProps {
  filters: Filter[]
  activeFilter: string
  onChange: (key: string) => void
}

export const ShiftSwapFilters = ({
  filters,
  activeFilter,
  onChange,
}: ShiftSwapFiltersProps) => (
  <div className="flex flex-wrap gap-2 px-3 pb-2">
    {filters.map(({ key, label }) => (
      <button
        key={key}
        onClick={() => onChange(key)}
        className={`px-3 py-1 rounded cursor-pointer ${
          activeFilter === key
            ? "bg-[#0F172B] text-white"
            : "bg-[#F1F5F9] text-[#62748E]"
        }`}
      >
        {label}
      </button>
    ))}
  </div>
)
